import { Spin } from 'antd'

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'
  className?: string
}

const LoadingSpinner = ({ size = 'medium', className = '' }: LoadingSpinnerProps) => {
  const antdSize = size === 'medium' ? 'default' : size

  return (
    <div className={className}>
      <Spin size={antdSize} />
    </div>
  )
}

export default LoadingSpinner